import { apiClient } from "../core/apiClient";

export interface BackendMenuProduct {
  id: string;
  nombre: string;
  precio: number;
  imagen_url?: string | null;
}

export interface BackendMenu {
  id: string;
  nombre: string;
  descripcion?: string;
  fecha: string; // YYYY-MM-DD
  imagen_url?: string | null;
}

export interface MenuService {
  getDailyMenus(): Promise<Record<string, string[]>>;
  upsertDailyMenu(date: Date, payload: UpsertDailyMenuPayload): Promise<void>;
  deleteDailyMenu(date: Date): Promise<void>;
  getDailyMenuForDate(date: Date): Promise<string[]>;
  getMenuByDate(date: Date): Promise<BackendMenu | null>;
  getMenusInRange(start: string, end: string): Promise<BackendMenu[]>;
}

const formatDateToString = (date: Date): string => date.toISOString().split("T")[0];

export const getDailyMenus = async (): Promise<Record<string, string[]>> => {
  const response = await apiClient.get<BackendMenu[]>(`/api/v1/menus`);
  const map: Record<string, string[]> = {};
  for (const menu of response.data) {
    map[menu.fecha] = [];
  }
  return map;
};

export type UpsertDailyMenuPayload = {
  nombre: string;
  descripcion?: string;
  imageFile?: File | null;
  productIds: string[];
};

export const upsertDailyMenu = async (
  date: Date,
  payload: UpsertDailyMenuPayload
): Promise<void> => {
  const fecha = formatDateToString(date);
  const form = new FormData();
  form.append("fecha", fecha);
  form.append("nombre", payload.nombre);
  if (payload.descripcion) form.append("descripcion", payload.descripcion);
  for (const id of payload.productIds) form.append("productIds", id);
  if (payload.imageFile) form.append("imagen", payload.imageFile);
  await apiClient.post(`/api/v1/menus/daily`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteDailyMenu = async (date: Date): Promise<void> => {
  // Estrategia: obtener el menú por fecha y borrarlo si existe
  const fecha = formatDateToString(date);
  const response = await apiClient.get<BackendMenu[]>(`/api/v1/menus/range/query`, {
    params: { start: fecha, end: fecha },
  });
  const found = response.data.find((m) => m.fecha === fecha);
  if (found) {
    await apiClient.delete(`/api/v1/menus/${found.id}`);
  }
};

export const getDailyMenuForDate = async (): Promise<string[]> => {
  return [];
};

export const getMenuByDate = async (date: Date): Promise<BackendMenu | null> => {
  const fecha = formatDateToString(date);
  const response = await apiClient.get<BackendMenu[]>(`/api/v1/menus/range/query`, {
    params: { start: fecha, end: fecha },
  });
  return response.data.find((m) => m.fecha === fecha) ?? null;
};

export const getMenusInRange = async (
  start: string,
  end: string
): Promise<BackendMenu[]> => {
  const response = await apiClient.get<BackendMenu[]>(`/api/v1/menus/range/query`, {
    params: { start, end },
  });
  return response.data;
};

const menuService: MenuService = {
  getDailyMenus,
  upsertDailyMenu,
  deleteDailyMenu,
  getDailyMenuForDate,
  getMenuByDate,
  getMenusInRange,
};

export default menuService;
